module.exports = __webpack_public_path__ + "images/6b8573b138c32c76f2347440f543cf67-quebec.png";